import React, { useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import AskDialog from '../../../components/common/dialog/AskDialog';
import { useNavigate } from 'react-router-dom';
import * as chanceApi from '../../../lib/api/chance';
import _ from 'lodash';
import { setChance } from '../../../modules/chanceModule/chance';
import {
  Box,
  Grid,
  Button,
  Typography,
  LinearProgress,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Chip,
  IconButton,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import ChanceConfirmContainer from './ChanceConfirmContainer';
import ChanceNeedsAnanlysisContainer from './ChanceNeedsAnanlysisContainer';
import ChanceEstimateContainer from './ChanceEstimateContainer';
import ChanceOrderContainer from './ChanceOrderContainer';
import ChanceStepInfoContainer from '../info/ChanceStepInfoContainer';
import ChanceGuideContainer from '../info/ChanceGuideContainer';
import useFieldConfig from '../../../hooks/useFieldConfig';
import ChanceFailModal from '../../../components/chancemng/info/ChanceFailModal';

const steps = [
  { value: 0, label: '기회 확인', color: 'info' },
  { value: 1, label: '기회 분석', color: 'error' },
  { value: 2, label: '매출 견적', color: 'success' },
  { value: 3, label: '수주 품의', color: 'secondary' },
];

const ChanceStepperContainer = ({ activeStep, activeTap, handleTabChange }) => {
  const stepperRef = useRef();

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { isFieldEnabled, isFieldRequired } = useFieldConfig('CHANCE');
  const [isAuth, setIsAuth] = useState(false);
  // 삭제 권한. 본인이 만든 것이거나 삭제 권한자여야 한다.
  // 되돌릴 수 없는 작업이라 서버에서도 다시 막는다.
  const [canDelete, setCanDelete] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { chance, user } = useSelector(({ chanceModule, auth }) => ({
    chance: chanceModule.chance.chance,
    user: auth.user,
  }));

  useEffect(() => {

    // 영업이익 마이너스 권한 
    const findIndex = _.findIndex(
      user?.privilegeList,
      (auth) => auth?.authTyp === 'NO_PERPROMANCE' && auth?.authYn === 'Y',
    );
    // console.log(findIndex, 'findIndex');
    if (findIndex !== -1) {
      setIsAuth(true);
    }
    // 삭제 권한은 서버에 물어본다.
    // 화면에서 권한목록만 뒤지면 "권한자" 는 알 수 있어도 "본인이 만든 것" 은 판단할 수 없다.


  }, [user]);

  const [message, setMessage] = useState(
    '기본사항 등록이 완료되지 못했습니다.',
  );
  // 삭제 권한 조회. 본인이 만든 것이거나 삭제 권한자면 참이다.
  useEffect(() => {
    if (!chance?.prjUuid) {
      setCanDelete(false);
      return;
    }
    chanceApi.getChanceDeletePermission(chance.prjUuid)
      .then((res) => setCanDelete(Boolean(res?.data?.allowed)))
      // 못 읽으면 숨긴다. 되돌릴 수 없는 작업이라 열어두는 것보다 안전하다.
      .catch(() => setCanDelete(false));
  }, [chance?.prjUuid]);

  const [visible, setVisible] = useState(false);
  const onCancle = () => {
    setVisible(false);
  };
  const onConfirm = () => {
    setVisible(false);
  };

  const [failVisible, setFailVisible] = useState(false);
  const onFailCancle = () => {
    setFailVisible(false);
  };
  const onFailConfirm = (failTxt) => {
    //수주실패
    onFailProject(failTxt);
    setFailVisible(false);
  };

  const onFailProject = async (failTxt) => {
    let dataToSubmit = {
      prjUuid: chance.prjUuid,
      cstStatus: '수주실패',
      failTxt: failTxt,
      useYn: 'N',
    };

    try {
      const res = await chanceApi.editChance(dataToSubmit);
      if (res.data) {
        navigate('/chancemng');
        enqueueSnackbar(`프로젝트 종료 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const [copyVisible, setCopyVisible] = useState(false);
  const onCopyCancle = () => {
    setCopyVisible(false);
  };
  const onCopyConfirm = () => {
    //프로젝트 복사
    onCopyProject();
    setCopyVisible(false);
  };

  const onCopyProject = async () => {
    try {
      const res = await chanceApi.copyChance(chance.prjUuid);
      if (res.data) {
        navigate('/chancemng');
        enqueueSnackbar(`프로젝트 복사 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  // xs 전용: 하단 고정 액션바의 "⋯" 더보기 메뉴
  const [moreAnchorEl, setMoreAnchorEl] = useState(null);
  const moreMenuOpen = Boolean(moreAnchorEl);
  const openMoreMenu = (e) => setMoreAnchorEl(e.currentTarget);
  const closeMoreMenu = () => setMoreAnchorEl(null);

  const [removeVisible, setRemoveVisible] = useState(false);
  const onRemoveCancle = () => {
    setRemoveVisible(false);
  };
  const onRemoveConfirm = () => {
    //프로젝트 삭제
    onRemoveProject();
    setRemoveVisible(false);
  };

  const onRemoveProject = async () => {
    try {
      const res = await chanceApi.removeChance(chance?.prjUuid);
      if (res.data) {
        navigate('/chancemng');
        enqueueSnackbar(`프로젝트 삭제 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const handleNext = async () => {
    //현재 단계에서 모든 상세가 입력되었는지 확인
    // 서버에서 최신 원가확정 상태 재조회
    let serverCostYn = chance?.costYn;
    if (activeStep === 1 || activeStep === 2) {
      try {
        const res = await chanceApi.getChance(chance.prjUuid);
        if (res.data.info) {
          dispatch(setChance(res.data.info));
          serverCostYn = res.data.info.costYn;
        }
      } catch (err) {
        // 실패 시 기존 Redux 상태로 진행
      }
    }

    const valid = checkValidation(serverCostYn);
    if (!valid) {
      setVisible(true);
      return;
    } else {
      let dataToSubmit = {
        prjUuid: chance.prjUuid,
      };

      if (Number(chance.cstGrade) === 1) {
        dataToSubmit.cstGrade = 2;
        dataToSubmit.cstStatus = '기회분석';
        updateChanceStatus(dataToSubmit);
      }

      if (Number(chance.cstGrade) === 2) {
        dataToSubmit.cstGrade = 3;
        dataToSubmit.cstStatus = '견적';
        updateChanceStatus(dataToSubmit);
      }

      if (Number(chance.cstGrade) === 3) {
        dataToSubmit.cstGrade = 4;
        dataToSubmit.cstStatus = '수주';
        updateOrderStatus(dataToSubmit);
      }
    }
  };

  const updateOrderStatus = async (dataToSubmit) => {
    try {
      const res = await chanceApi.getEstimateCount(chance.prjUuid);
      if (!res.data.count || res.data.count === 0) {
        setMessage('작성된 견적서가 없습니다. 견적서를 작성하세요');
        setVisible(true);
        return;
      } else {
        updateChanceStatus(dataToSubmit);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  /**
   * 단계를 옮긴 뒤 열어줄 탭. 주소에 들어가는 값이라 1부터 센다.
   *
   * 그 단계에서 실제로 할 일이 있는 탭으로 보낸다.
   *   기회분석 → 기회정보 · 매출견적 → 견적서 · 수주품의 → 수주품의서
   *
   * 예전에는 기회분석(등급 2)일 때 0이 그대로 나가서 탭이 -1 이 됐고,
   * 어느 탭도 안 걸려 화면이 비어 보였다.
   */
  const nextTabOf = (cstGrade) => {
    switch (Number(cstGrade)) {
      case 2: return 1; // 기회분석  → 기회정보
      case 3: return 2; // 매출견적  → 견적서
      case 4: return 3; // 수주품의  → 수주품의서
      default: return 1;
    }
  };

  const updateChanceStatus = async (dataToSubmit) => {
    const moveTab = nextTabOf(dataToSubmit.cstGrade);
    try {
      const res = await chanceApi.editChance(dataToSubmit);
      if (res.data) {
        dispatch(setChance(res.data.info));
        navigate(
          `/chancemng/${dataToSubmit.prjUuid}/${dataToSubmit.cstGrade}/${moveTab}`,
        );
        enqueueSnackbar(`[${dataToSubmit.cstStatus}] 상태 변경 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const checkValidation = (serverCostYn) => {
    let valid = false;
    const costYnValue = serverCostYn || chance?.costYn;

    if (activeStep === 0) {
      valid = checkValid1();
    } else if (activeStep === 1) {
      valid = checkValid2(costYnValue);

      if (valid) {
        if (!costYnValue || costYnValue !== 'Y') {
          valid = false;
          setMessage(
            '원가산출이 확정되지 않았습니다. 원가산출관리에서 확정하십시오',
          );
        }
      }
    } else if (activeStep === 2) {
      valid = checkValid3(costYnValue);

      if (valid) {
        if (!costYnValue || costYnValue !== 'Y') {
          valid = false;
          setMessage(
            '원가산출이 확정되지 않았습니다. 원가산출관리에서 확정하십시오',
          );
        }
      }
    }

    return valid;
  };

  const checkValid1 = () => {
    let valid = true;
    if (
      chance.cstNm === null ||
      chance.cstNm === undefined ||
      chance.cstNm === ''
    ) {
      setMessage('사업명이 등록되지 않았습니다.');
      valid = false;
    }
    if (
      chance.prjImpt === null ||
      chance.prjImpt === undefined ||
      chance.prjImpt === ''
    ) {
      setMessage('프로젝트 중요도가 등록되지 않았습니다.');
      valid = false;
    }
    // 예산여부: 필드 설정에서 필수로 지정된 경우에만 체크
    if (isFieldEnabled('bugetYn') && isFieldRequired('bugetYn')) {
      if (
        chance.bugetYn === null ||
        chance.bugetYn === undefined ||
        chance.bugetYn === ''
      ) {
        setMessage('예산여부가 등록되지 않았습니다.');
        valid = false;
      }
    }
    return valid;
  };
  const checkValid2 = (costYnValue) => {
    let valid = checkValid1();

    // if (
    //   chance.incTyp === null ||
    //   chance.incTyp === undefined ||
    //   chance.incTyp === ''
    // ) {
    //   setMessage('거래처 유형이 등록되지 않았습니다.');
    //   valid = false;
    // }

    // if (
    //   chance.solutionTyp === null ||
    //   chance.solutionTyp === undefined ||
    //   chance.solutionTyp === ''
    // ) {
    //   setMessage('아이템 구분이 등록되지 않았습니다.');
    //   valid = false;
    // }

    if (isFieldEnabled('productYn')) {
      if (
        chance.productYn === null ||
        chance.productYn === undefined ||
        chance.productYn === ''
      ) {
        setMessage('제품 여부가 등록되지 않았습니다.');
        valid = false;
      }
    }

    if (isFieldEnabled('partnerInc')) {
      if (
        chance.vendorCmp === null ||
        chance.vendorCmp === undefined ||
        chance.vendorCmp === ''
      ) {
        setMessage('매출처가 등록되지 않았습니다.');
        valid = false;
      }
    }

    // if (
    //   chance.vendorEmp === null ||
    //   chance.vendorEmp === undefined ||
    //   chance.vendorEmp === ''
    // ) {
    //   setMessage('매출처 담당자가 등록되지 않았습니다.');
    //   valid = false;
    // }

    if (
      chance.expBenefitRate === null ||
      chance.expBenefitRate === undefined ||
      chance.expBenefitRate === ''
    ) {
      setMessage('원가산출이 완료되지 않았습니다');
      valid = false;
    }

    if (
      chance.expSales === null ||
      chance.expSales === undefined ||
      chance.expSales === ''
    ) {
      setMessage('원가산출이 완료되지 않았습니다');
      valid = false;
    }

    if (
      chance.expBuy === null ||
      chance.expBuy === undefined ||
      chance.expBuy === ''
    ) {
      setMessage('원가산출이 완료되지 않았습니다');
      valid = false;
    }

    //isAuth가 true이면 skip => "NO_PERPROMANCE" 권한자는 true
    if (!isAuth) {
      // isAuth가 true일떄는 계산안함.
      // if (chance?.expBenefitRate === '0.00') {
      //   setMessage('예상이익률이 0.00입니다. 재확인하세요.');
      //   valid = false;
      // }
      const numberExpRate = Number(chance?.expBenefitRate);
      if (numberExpRate <= 0) {
        setMessage('예상이익률이 0 이하입니다. 재확인하세요.');
        valid = false;
      }
    }

    if (
      chance.expDay === null ||
      chance.expDay === undefined ||
      chance.expDay === ''
    ) {
      setMessage('매출(수금)예정일이 등록되지 않았습니다');
      valid = false;
    }

    if (costYnValue !== 'Y') {
      setMessage('원가산출이 확정되지 않았습니다.');
      valid = false;
    }

    return valid;
  };
  const checkValid3 = (costYnValue) => {
    let valid = checkValid1() && checkValid2(costYnValue);
    // if (valid) {
    //   if (
    //     chance.mtnFreeSt === null ||
    //     chance.mtnFreeSt === undefined ||
    //     chance.mtnFreeSt === ''
    //   ) {
    //     setMessage('무상 유지 보수 시작일이 등록되지 않았습니다');
    //     valid = false;
    //   }

    //   if (
    //     chance.mtnFreeEd === null ||
    //     chance.mtnFreeEd === undefined ||
    //     chance.mtnFreeEd === ''
    //   ) {
    //     setMessage('무상 유지 보수 종료일이 등록되지 않았습니다');
    //     valid = false;
    //   }
    // }
    return valid;
  };

  // 마지막 단계(수주품의)에서는 "다음 단계" 버튼이 없다 — 파괴적 동작(기회 실패)을
  // 주 버튼 자리에 올리지 않는다는 규칙은 모바일과 동일하게 데스크톱 헤더 카드에도 적용된다.
  const hasNextStep = activeStep < steps.length - 1;
  // 원래 Stepper 로직 그대로: 마지막 단계에 있을 때만 전부 완료 처리된다(단계별 완료가 아님).
  const forceAllCompleted = activeStep === steps.length - 1;

  return (
    <Box sx={{ width: '100%' }}>
      {/* xs: 요약 카드(2열 그리드) - 데스크톱 전용 압축 헤더 카드와 별개, 그대로 유지 */}
      <Grid
        container
        sx={{ display: { xs: 'flex', sm: 'none' }, my: 0 }}
      >
        <Grid item xs={12}>
          <ChanceStepInfoContainer />
        </Grid>
      </Grid>

      <div ref={stepperRef}></div>

      {/* sm+: 데스크톱 압축 헤더 카드 - 뒤로가기/제목/단계칩/액션(Row1) + 요약 스트립(Row2) + 슬림 스테퍼(Row3).
          예전의 다크 헤더 카드·절반폭 요약 카드·회색 스테퍼 블록·액션 버튼 줄을 한 장으로 합쳤다. */}
      <Paper
        variant="outlined"
        sx={{
          display: { xs: 'none', sm: 'block' },
          mx: 2,
          mt: 2,
          px: 2,
          py: 1.5,
        }}
      >
        {/* Row 1: 뒤로가기 · 제목/번호·고객사 · 단계 칩 · 액션 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton
            size="small"
            onClick={() => navigate('/chancemng')}
            aria-label="goBack"
          >
            <ArrowBackIcon fontSize="small" />
          </IconButton>

          <Box sx={{ minWidth: 0, flexShrink: 1, mr: 1 }}>
            <Typography variant="h6" component="div" noWrap title={chance?.cstNm}>
              {chance?.cstNm}
            </Typography>
            <Typography variant="caption" component="div" color="text.secondary" noWrap>
              {chance?.prjNo}
              {chance?.prjNo && chance?.customerNm ? ' · ' : ''}
              {chance?.customerNm}
            </Typography>
          </Box>

          <Chip
            size="small"
            label={chance?.cstStatus}
            color={steps[activeStep]?.color === 'default' ? 'primary' : steps[activeStep]?.color}
            sx={{ fontWeight: 500, flexShrink: 0 }}
          />

          <Box sx={{ flex: '1 1 auto' }} />

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
            <Button
              size="small"
              variant="outlined"
              color="inherit"
              onClick={() => setCopyVisible(true)}
            >
              기회 복사
            </Button>
            <Button
              size="small"
              variant="text"
              color="error"
              onClick={() => setFailVisible(true)}
            >
              기회 실패
            </Button>
            {hasNextStep && (
              <Button
                size="small"
                variant="contained"
                color={steps[activeStep + 1].color}
                onClick={handleNext}
              >
                {steps[activeStep + 1].label}
              </Button>
            )}
          </Box>
        </Box>

        {/* Row 2: 요약 스트립 (매출처 · 고객사 · 매출(수금)예정일 · 매출액 · 매출 이익 · 예상 이익률) */}
        <Box sx={{ mt: 1, pt: 1, borderTop: 1, borderColor: 'divider' }}>
          <ChanceStepInfoContainer />
        </Box>

        {/* Row 3: 슬림 스테퍼 - 작은 점 + 라벨, 회색 배경 없음, ~32px */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: 1,
            pt: 1,
            borderTop: 1,
            borderColor: 'divider',
            minHeight: 32,
          }}
        >
          {steps.map((step, idx) => {
            const isActive = idx === activeStep;
            const isCompleted = idx < activeStep || forceAllCompleted;
            const dotColor = isActive || isCompleted ? step.color : undefined;
            return (
              <React.Fragment key={step.label}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexShrink: 0 }}>
                  <Box
                    sx={{
                      width: 18,
                      height: 18,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      fontSize: 11,
                      fontWeight: 600,
                      lineHeight: 1,
                      color: dotColor ? `${dotColor}.contrastText` : 'text.disabled',
                      bgcolor: dotColor ? `${dotColor}.main` : 'action.disabledBackground',
                    }}
                  >
                    {isCompleted ? <CheckIcon sx={{ fontSize: 12 }} /> : idx + 1}
                  </Box>
                  <Typography
                    variant="caption"
                    component="span"
                    sx={{
                      whiteSpace: 'nowrap',
                      color: isActive ? 'text.primary' : 'text.secondary',
                      fontWeight: isActive ? 600 : 400,
                    }}
                  >
                    {step.label}
                  </Typography>
                </Box>
                {idx < steps.length - 1 && (
                  <Box
                    sx={{
                      flex: '1 1 auto',
                      height: 2,
                      mx: 1.5,
                      bgcolor: idx < activeStep || forceAllCompleted ? `${step.color}.main` : 'divider',
                    }}
                  />
                )}
              </React.Fragment>
            );
          })}
        </Box>
      </Paper>

      {/* xs: 축약 진행률 표시 ("2/4 기회 분석" + 얇은 진행바), 배경/여백 없는 플레인 라인 */}
      <Box sx={{ display: { xs: 'block', sm: 'none' }, mt: 0.5, mb: 0.75 }}>
        <Typography variant="caption" component="div" color="text.secondary" sx={{ mb: 0.25, lineHeight: 1.2 }}>
          {activeStep + 1}/{steps.length} {steps[activeStep]?.label}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={((activeStep + 1) / steps.length) * 100}
          color={steps[activeStep]?.color === 'default' ? 'primary' : steps[activeStep]?.color}
          sx={{ height: 4, borderRadius: 2 }}
        />
      </Box>

      {/* xs: 하단 고정 액션바 - 다음 단계(주 동작) + "⋯" 더보기(기회 복사/기회 실패).
          마지막 단계(수주품의)에서는 "수주 실패"(파괴적 동작)를 주 버튼으로 두지 않는다.
          그 단계엔 대체할 비파괴적 동작이 없으므로 주 버튼 없이 더보기만 보여준다. */}
      <Box
        sx={{
          display: { xs: 'flex', sm: 'none' },
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: (theme) => theme.zIndex.appBar,
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
          px: 1.5,
          py: 1,
          backgroundColor: 'background.paper',
          borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Button
          size="small"
          variant="outlined"
          color="inherit"
          onClick={openMoreMenu}
          aria-label="더보기 메뉴 열기"
          startIcon={<MoreVertIcon fontSize="small" />}
          sx={{ minWidth: 0, px: 1, flexShrink: 0 }}
        >
          더보기
        </Button>
        <Menu anchorEl={moreAnchorEl} open={moreMenuOpen} onClose={closeMoreMenu}>
          <MenuItem
            onClick={() => {
              closeMoreMenu();
              setCopyVisible(true);
            }}
          >
            <ListItemIcon>
              <ContentCopyIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>기회 복사</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              closeMoreMenu();
              setFailVisible(true);
            }}
          >
            <ListItemIcon>
              <CancelIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>기회 실패</ListItemText>
          </MenuItem>
          {canDelete && (
            <MenuItem
              onClick={() => {
                closeMoreMenu();
                setRemoveVisible(true);
              }}
            >
              <ListItemIcon>
                <DeleteIcon fontSize="small" color="error" />
              </ListItemIcon>
              <ListItemText sx={{ color: 'error.main' }}>삭제</ListItemText>
            </MenuItem>
          )}
        </Menu>

        <Box sx={{ flex: '1 1 auto' }} />

        {activeStep < steps.length - 1 && (
          <Button
            variant="contained"
            color={steps[activeStep + 1].color}
            onClick={handleNext}
            fullWidth
            sx={{ maxWidth: 260 }}
          >
            {steps[activeStep + 1].label}
          </Button>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        {activeStep === 0 && (
          <ChanceConfirmContainer
            activeTap={activeTap}
            handleTabChange={handleTabChange}
            stepperRef={stepperRef}
          />
        )}
        {activeStep === 1 && (
          <ChanceNeedsAnanlysisContainer
            activeTap={activeTap}
            handleTabChange={handleTabChange}
            stepperRef={stepperRef}
          />
        )}
        {activeStep === 2 && (
          <ChanceEstimateContainer
            activeTap={activeTap}
            handleTabChange={handleTabChange}
            stepperRef={stepperRef}
          />
        )}
        {activeStep === 3 && (
          <ChanceOrderContainer
            activeTap={activeTap}
            handleTabChange={handleTabChange}
            stepperRef={stepperRef}
          />
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          py: 2,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box>
          {canDelete && (
            <Button
              variant="contained"
              color="error"
              onClick={() => setRemoveVisible(true)}
            >
              삭제
            </Button>
          )}
        </Box>

        <Box sx={{ flex: '1 1 auto' }} />
        <Box sx={{ mr: 2 }}>
          <Button
            variant="contained"
            color="default"
            onClick={() => setFailVisible(true)}
          >
            수주 실패
          </Button>
        </Box>
        {activeStep < steps.length - 1 && (
          <Button
            variant="contained"
            color={steps[activeStep + 1].color}
            onClick={handleNext}
          >
            {steps[activeStep + 1].label}
          </Button>
        )}
      </Box>

      {/* xs: 하단 고정 액션바에 가려지지 않도록 페이지 맨 끝에 자리 확보용 스페이서 */}
      <Box sx={{ display: { xs: 'block', sm: 'none' }, height: 64 }} />

      <AskDialog
        visible={visible}
        title="다음단계 이동"
        description={message}
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
      <ChanceFailModal
        visible={failVisible}
        title="경고 : 프로젝트 수주 실패"
        description="더이상 사업 진행이 되지 않습니다."
        onConfirm={onFailConfirm}
        onCancle={onFailCancle}
      />
      <AskDialog
        visible={copyVisible}
        title="프로젝트 복사"
        description="해당 프로젝트를 복사하시겠습니까?"
        onConfirm={onCopyConfirm}
        onCancle={onCopyCancle}
      />
      <AskDialog
        visible={removeVisible}
        title="프로젝트 삭제"
        description="해당 프로젝트를 삭제하시겠습니까?(복구 불가)"
        onConfirm={onRemoveConfirm}
        onCancle={onRemoveCancle}
      />
    </Box>
  );
};

export default ChanceStepperContainer;
